import React, { Component } from 'react';
import EirButton from '../eir-button/EirButton';

import {
  Collapse,
  CardBody,
  Card,
  CardHeader,
  ListGroup,
  ListGroupItem
} from 'reactstrap';

class FooterMobileAccordion extends Component {
  constructor(props) {
    super(props);
    this.state = { collapse: false };
  }

  toggle = () => {
    this.setState({ collapse: !this.state.collapse });
  };

  render() {
    let chevron, directLink;
    if (this.state.collapse) {
      chevron = <span className="eir-icon eir-icon--sm icon-arrowup--dark float-right" />;
    } else {
      chevron = <span className="eir-icon eir-icon--sm icon-arrowdown--dark float-right" />;
    }
    directLink = <span className="eir-icon eir-icon--sm icon-arrowright-black float-right" />;

    return (
      <Card className="footer-card">
        <CardHeader className="footer-card__header" onClick={this.toggle}>
          {/* {(this.props.children.length < 1) ? <a href={this.props.link.link} className={'footer-links first-level-direct-link'} >{this.props.title}{directLink}</a> : <span className={'footer-links footer-parent-link'}>{this.props.title}{chevron}</span>} */}
          {(this.props.children.length < 1) ? <a href={this.props.link.link} className={'footer-links first-level-direct-link'} >{this.props.title}</a> : <span className={'footer-links footer-parent-link'}>{this.props.title}{chevron}</span>}
          {/* {chevron} */}
        </CardHeader>
        {/* added as part of business - footer changes - EIRZWM-501 */}
        {this.props.children.length > 0 &&
          <Collapse isOpen={this.state.collapse}>
            <CardBody className="footer-card__body">
              <ListGroup className="footer-card__menu">
                {this.props.children.map((navItem, index) => {
                  return (
                    <ListGroupItem key={index} className="footer-list">
                      <EirButton
                        {...navItem.link}
                        className={'footer-links'}
                      />
                    </ListGroupItem>
                  );
                })}
              </ListGroup>
            </CardBody>
          </Collapse>
        }
      </Card>
    );
  }
}

export default FooterMobileAccordion;
